import { z } from "zod/mini"

const IntegrationFieldConfigSchema = z.object({
	label: z.nullish(z.string()),
	placeholder: z.optional(z.string()),
	catalog: z.optional(z.string()),
})

export const IntegrationFieldModelSchema = z.object({
	type: z.literal("IntegrationFields"),
	fieldset: z.nullish(z.string()),
	config: z.optional(IntegrationFieldConfigSchema),
})

export type IntegrationFieldModel = z.infer<typeof IntegrationFieldModelSchema>
